module.exports = __webpack_public_path__ + "icon-risk.png?25912f1bf12f4d0d846b6405c4bdb777";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-risk.png
// module id = 66
// module chunks = 0